import { render, staticRenderFns } from "./configureUser.vue?vue&type=template&id=5cec7fbc&scoped=true"
import script from "./configureUser.vue?vue&type=script&lang=js"
export * from "./configureUser.vue?vue&type=script&lang=js"
import style0 from "./configureUser.vue?vue&type=style&index=0&id=5cec7fbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cec7fbc",
  null
  
)

export default component.exports